import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { LoyaltyCurrencyService } from '@rd/core/services/loyalty-currency/loyalty-currency.service';
import { CoreState } from '@rd/core/store/reducers';

@Injectable()
export class StarLoyaltyCurrencyService extends LoyaltyCurrencyService {
  constructor(
    store: Store<CoreState>,
    private translateService: TranslateService,
  ) {
    super(store);
  }

  getPointsActivityTitleLoyaltyCurrencyName(): string {
    return this.translateService.instant('header.points_activity.sub_header');
  }
}
